// Frontend React Component
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { set } from 'mongoose';
import UserContext from '../../contexts/UserContext';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const DecryptionHandler = () => {
    const [encryptedData, setEncryptedData] = useState('');
    const [plainText, setPlainText] = useState('');
    const [status, setStatus] = useState('idle'); // idle, loading, success, error
    const [message, setMessage] = useState('');
    const [isValidated, setIsValidated] = useState(false);
    const [testMode, setTestMode] = useState(false);
    const [dataDecrypted, setDataDecrypted] = useState(false);
    const [decryptedData, setDecryptedData] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const {user,setUser} = useContext(UserContext);
      const navigate = useNavigate();

    // Function to handle encryption API call (for testing only)
    // const handleEncryption = async (dataToEncrypt) => {
    //     setStatus('loading');
    //     setMessage('Encrypting data for testing...');

    //     try {
    //         const response = await axios.post(`${process.env.REACT_APP_API_URI}/api/encrypt`, {
    //             plainText: dataToEncrypt
    //         }, {
    //             timeout: 10000,
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             }
    //         });

    //         if (response.data.success) {
    //             setEncryptedData(response.data.encryptedData);
    //             setStatus('success');
    //             setMessage('Data encrypted successfully! Now testing decryption...');
                
    //             // Automatically test decryption after encryption
    //             setTimeout(() => {
    //                 handleDecryption(response.data.encryptedData);
    //             }, 1000);
    //         }

    //     } catch (error) {
    //         setStatus('error');
    //         if (error.response) {
    //             setMessage(error.response.data.error || 'Encryption failed');
    //         } else {
    //             setMessage('Network error during encryption');
    //         }
    //     }
    // };

    // Function to handle decryption API call
    const handleDecryption = async (dataToDecrypt) => {
        setStatus('loading');
        setMessage('Processing encrypted data...');
        setLoading(true);
        console.log(dataToDecrypt);

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URI}/api/decrypt-and-validate`, {
                encryptedData: JSON.stringify({token:dataToDecrypt}), // Send the urlSafeString
            }, {
                timeout: 10000, // 10 second timeout
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.data.success) {
                setStatus('success');
                setMessage('Data successfully decrypted and validated!');
                setIsValidated(true);
                
                // Handle successful validation here
                // You can redirect, show success UI, etc.
                console.log('✅ Validation successful');

                setDataDecrypted(true);
                setDecryptedData(response.data.decryptedData);
                setUser({...response.data.decryptedData,role:"Umaal"});
                setLoading(false);
                Cookies.set('accessToken', 'umaal', { expires: 1 });
                navigate('/silat/home');
                // Optional: Clear the encrypted data after successful processing
                setTimeout(() => {
                    setEncryptedData('');
                }, 2000);
            }

        } catch (error) {
            setStatus('error');
            setIsValidated(false);
            setDataDecrypted(false);
            setLoading(false);
            setDecryptedData('');

            if (error.response) {
                // Server responded with error status
                setError('Server error occurred');
                console.error('❌ Server error:', error.response.data);
            } else if (error.request) {
                // Network error
                setError('Network error - unable to reach server');
                console.error('❌ Network error:', error.message);
            } else {
                // Other error
                setError('An unexpected error occurred');
                console.error('❌ Error:', error.message);
            }
        }
    };

    // useEffect to automatically process encrypted data when received
    useEffect(() => {
        const queryString = window.location.search;
    
    // Extract the 'q' parameter manually
        const match = queryString.match(/[?&]q=([^&]*)/);
        const encryptedData = match ? match[1] : null;
        console.log(encryptedData);
        if (encryptedData && encryptedData.trim() !== '') {
            handleDecryption(encryptedData);
        }
    }, []);

    // Function to manually trigger decryption (if needed)
    const manualDecrypt = () => {
        if (encryptedData) {
            handleDecryption(encryptedData);
        }
    };

    return (
        <div style={{ 
            padding: '20px', 
            maxWidth: '600px', 
            margin: '50px auto',
            fontFamily: 'Arial, sans-serif'
        }}>
            {loading ? (
                <div style={{
                    padding: '20px',
                    backgroundColor: '#d1ecf1',
                    border: '1px solid #bee5eb',
                    borderRadius: '5px',
                    textAlign: 'center'
                }}>
                    <h3>🔄 Processing encrypted data...</h3>
                    <p>Please wait while we decrypt and validate your data.</p>
                </div>
            ) : dataDecrypted ? (
                <div style={{
                    padding: '20px',
                    backgroundColor: '#d4edda',
                    border: '1px solid #c3e6cb',
                    borderRadius: '5px',
                    color: '#155724'
                }}>
                    <h3>✅ Encrypted data success!</h3>
                    <p><strong>Status:</strong> Data decrypted and validated successfully</p>
                    {/* <p><strong>Decrypted Data:</strong> {decryptedData}</p> */}
                    {decryptedData && typeof decryptedData === 'object' ? (
                        <div>
                            <p><strong>Decrypted Data:</strong></p>
                            <pre style={{
                                backgroundColor: '#f8f9fa',
                                padding: '10px',
                                borderRadius: '3px',
                                overflow: 'auto'
                            }}>
                                {JSON.stringify(decryptedData, null, 2)}
                            </pre>
                        </div>
                    ) : decryptedData ? (
                        <p><strong>Decrypted Data:</strong> {decryptedData}</p>
                    ) : null}
                </div>
            ) : (
                <div style={{
                    padding: '20px',
                    backgroundColor: '#f8d7da',
                    border: '1px solid #f5c6cb',
                    borderRadius: '5px',
                    color: '#721c24'
                }}>
                    <h3>❌ Failed to get decrypted data</h3>
                    <p><strong>Error:</strong> {error}</p>
                    <p>Please check your encrypted data and try again.</p>
                </div>
            )}

        </div>
    );
};

export default DecryptionHandler;